import { Routes } from '@angular/router';
import { unsavedChangesGuard } from './guards/unsaved-changes.guard';
import { authGuard } from './guards/auth.guard';
import { loginGuard } from './guards/login.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'login',
    // canActivate: [loginGuard],
    loadComponent: () => import('./features/auth/pages/rs-login/rs-login.page').then( m => m.RsLoginPage)
  },
  {
    path: 'dashboard',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-dashboard/rs-dashboard.page').then( m => m.RsDashboardPage),
    data: { 
      showHeader : true,
      title : {
        showTitle: false,
        label: 'test'
      },
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'dashboard'
      }
    }
  },
  {
    path: 'customer360',
    canActivateChild: [authGuard],
    loadComponent: () => import('./features/rs-customer360/rs-customer360.page').then( m => m.RsCustomer360Page),
    data: { 
      showHeader : true,
      title : {
        showTitle: true,
        label: 'Influencer Journey'
      },
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'customer360'
      }
    }
  },
  {
  path: 'push-notification',
  canActivate: [authGuard],
  loadComponent: () => import('./features/rs-push-notification/rs-push-notification.page').then(m => m.RsPushNotificationPage),
  data: {
    showHeader: true,
    title: {
      showTitle: true,
      label: 'Push Notification'
    },
    showSearch: true,
    menu: {
      showMenu: true,
      highlightMenu: 'pushNotification'
    }
  }
},
  {
    path: 'token-request',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-token-request/rs-token-request.page').then( m => m.RsTokenRequestPage),
    data: { 
      showHeader : true,
      title : {
        showTitle: true,
        label: ''
      },
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'tokenRequest'
      }
    }
  },
  {
    path: 'loyalty-program',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-loyalty-program/rs-loyalty-program.page').then( m => m.RsLoyaltyProgramPage),
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Programs'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'loyaltyProgram'
      }
    }
  },
  {
    path: 'token-request-details',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-token-request-detail/rs-token-request-detail.page').then( m => m.RsTokenRequestDetailPage),
    data: { 
      showHeader : true,
      title : {
        showTitle: true,
        label: ''
      },
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'tokenRequest'
      }
    }
  },
  {
    path: 'loyalty-program/create',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-loyalty-program-create/rs-loyalty-program-create.page').then( m => m.RsLoyaltyProgramCreatePage),
    canDeactivate: [unsavedChangesGuard],
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Programs'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'loyaltyProgram'
      }
    }
  },
  {
    path: 'loyalty-program/:id/edit',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-loyalty-program-create/rs-loyalty-program-create.page').then( m => m.RsLoyaltyProgramCreatePage),
    canDeactivate: [unsavedChangesGuard],
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Programs'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'loyaltyProgram'
      }
    }
  },
  {
    path: 'loyalty-program/:id',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-loyalty-program-detail/rs-loyalty-program-detail.page').then( m => m.RsLoyaltyProgramDetailPage),
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Programs'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'loyaltyProgram'
      }
    }
  },
  {
    path: 'loyalty-products',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-loyalty-products/rs-loyalty-products.page').then(m => m.RsLoyaltyProductsPage),
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Products'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'loyaltyProducts'
      }
    }
  },
  {
    path: 'loyalty-benefits',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-loyalty-benefits/rs-loyalty-benefits.page').then(m => m.RsLoyaltyBenefitsPage),
    data: {
      showHeader: true,
      title: { showTitle: true, label: 'Benefits' },
      showSearch: false,
      menu: { showMenu: true, highlightMenu: 'loyaltyBenefits' }
    }
  },
  {
    path: 'member-benefits',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-member-benefits-list/rs-member-benefits-list.page').then(m => m.RsMemberBenefitsListPage),
    data: {
      showHeader: true,
      title: { showTitle: true, label: 'Member Benefits' },
      showSearch: false,
      menu: { showMenu: true, highlightMenu: 'memberBenefits' }
    }
  },
  {
    path: 'loyalty-benefits/create',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-loyalty-benefit-form/rs-loyalty-benefit-form.page').then(m => m.RsLoyaltyBenefitFormPage),
    canDeactivate: [unsavedChangesGuard],
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Benefits'
      },
      showSearch: false,
      menu: {
        showMenu: true,
        highlightMenu: 'loyaltyBenefits'
      }
    }
  },
  {
    path: 'loyalty-benefits/:id/edit',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-loyalty-benefit-form/rs-loyalty-benefit-form.page').then(m => m.RsLoyaltyBenefitFormPage),
    canDeactivate: [unsavedChangesGuard],
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Benefits'
      },
      showSearch: false,
      menu: {
        showMenu: true,
        highlightMenu: 'loyaltyBenefits'
      }
    }
  },
  {
    path: 'loyalty-schemes',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-loyalty-schemes/rs-loyalty-schemes.page').then(m => m.RsLoyaltySchemesPage),
    data: {
      showHeader: true,
      title: { showTitle: true, label: 'Schemes' },
      showSearch: false,
      menu: { showMenu: true, highlightMenu: 'loyaltySchemes' }
    }
  },
  {
    path: 'loyalty-schemes/create',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-loyalty-scheme-form/rs-loyalty-scheme-form.page').then(m => m.RsLoyaltySchemeFormPage),
    canDeactivate: [unsavedChangesGuard],
    data: {
      showHeader: true,
      title: { showTitle: true, label: 'Schemes' },
      showSearch: false,
      menu: { showMenu: true, highlightMenu: 'loyaltySchemes' }
    }
  },
  {
    path: 'loyalty-schemes/:id/edit',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-loyalty-scheme-form/rs-loyalty-scheme-form.page').then(m => m.RsLoyaltySchemeFormPage),
    canDeactivate: [unsavedChangesGuard],
    data: {
      showHeader: true,
      title: { showTitle: true, label: 'Schemes' },
      showSearch: false,
      menu: { showMenu: true, highlightMenu: 'loyaltySchemes' }
    }
  },
  {
    path: 'loyalty-products/add-manually',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-loyalty-products-add-manually/rs-loyalty-products-add-manually.page').then(m => m.RsLoyaltyProductsAddManuallyPage),
    canDeactivate: [unsavedChangesGuard],
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Products'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'loyaltyProducts'
      }
    }
  },
  {
    path: 'loyalty-products/:id/edit',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-loyalty-product-edit/rs-loyalty-product-edit.page').then(m => m.RsLoyaltyProductEditPage),
    canDeactivate: [unsavedChangesGuard],
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Products'
      },
      showSearch: false,
      menu: {
        showMenu: true,
        highlightMenu: 'loyaltyProducts'
      }
    }
  },
  {
    path: 'loyalty-transactions/:transactionId',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/rs-loyalty-transaction-detail/rs-loyalty-transaction-detail.page').then(
        (m) => m.RsLoyaltyTransactionDetailPage,
      ),
    data: {
      showHeader: true,
      title: { showTitle: true, label: 'Transaction' },
      showSearch: true,
      menu: { showMenu: true, highlightMenu: 'loyaltyTransactions' },
    },
  },
  {
    path: 'loyalty-transactions',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/rs-loyalty-transactions/rs-loyalty-transactions.page').then(
        (m) => m.RsLoyaltyTransactionsPage,
      ),
    data: {
      showHeader: true,
      title: { showTitle: true, label: 'Transactions' },
      showSearch: true,
      menu: { showMenu: true, highlightMenu: 'loyaltyTransactions' },
    },
  },
  {
    path: 'loyalty-members',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-loyalty-members/rs-loyalty-members.page').then(m => m.RsLoyaltyMembersPage),
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Member'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'loyaltyMembers'
      }
    }
  },
  {
    path: 'loyalty-members/:memberId/transactions/:transactionId',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/rs-loyalty-transaction-detail/rs-loyalty-transaction-detail.page').then(
        (m) => m.RsLoyaltyTransactionDetailPage,
      ),
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Transaction',
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'loyaltyMembers',
      },
    },
  },
  {
    path: 'loyalty-members/:id',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-loyalty-member-detail/rs-loyalty-member-detail.page').then(m => m.RsLoyaltyMemberDetailPage),
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Member'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'loyaltyMembers'
      }
    }
  },
  {
    path: 'dispatch-approval',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-dispatch-approval/rs-dispatch-approval.page').then( m => m.RsDispatchApprovalPage),
    data: { 
      showHeader : true,
      title : {
        showTitle: true,
        label: ''
      },
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'dispatchApproval'
      }
    }
  },
  {
    path: 'survey',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-survey/rs-survey.page').then(m => m.RsSurveyPage),
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Survey'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'survey'
      }
    }
  },
  {
    // NOTE: assumed class name RsSurveyResponsePage / path
    // './features/rs-survey/rs-survey-response.page' based on this project's
    // naming convention — the rs-survey-response_page.ts you uploaded is
    // actually a duplicate of rs-survey.page.ts (selector 'app-rs-survey',
    // class RsSurveyPage), so I couldn't confirm the real class/file name.
    // Please correct the import below if it doesn't match your actual file.
    path: 'survey/response/:surveyId',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-survey/rs-survey-response/rs-survey-response.page').then(m => m.RsSurveyResponsePage),
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Survey Responses'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'survey'
      }
    }
  },
  {
    path: 'access-control',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-access-control/rs-access-control.page').then( m => m.RsAccessControlPage),
    data: { 
      showHeader : true,
      title : {
        showTitle: true,
        label: 'Portal Settings'
      },
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'accessControl'
      },
      // secondaryMenu : {
      //   showMenu: true,
      //   highlightMenu: 'accessControl'
      // }
    }
  },
  {
    path: 'banner-settings',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-banner-settings/rs-banner-settings.page').then( m => m.RsBannerSettingsPage),
    data: { 
      showHeader : true,
      title : {
        showTitle: true,
        label: 'Portal Settings'
      },
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'bannerSettings'
      },
      // secondaryMenu : {
      //   showMenu: true,
      //   highlightMenu: 'bannerSettings'
      // }
    }
  },
  {
    path: 'bank-payout',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-bank-payout/rs-bank-payout.page').then( m => m.RsBankPayoutPage),
    data: { 
      showHeader : true,
      title : {
        showTitle: true,
        label: 'Portal Settings'
      },
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'bankPayout'
      },
      // secondaryMenu : {
      //   showMenu: true,
      //   highlightMenu: 'bankPayout'
      // }
    }
  },
  {
    path: 'location-settings',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-location-settings/rs-location-settings.page').then( m => m.RsLocationSettingsPage),
    data: { 
      showHeader : true,
      title : {
        showTitle: true,
        label: 'Portal Settings'
      },
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'locationSettings'
      },
      // secondaryMenu : {
      //   showMenu: true,
      //   highlightMenu: 'locationSettings'
      // }
    }
  },
  {
    path: 'manage-approvals',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-manage-approvals/rs-manage-approvals.page').then( m => m.RsManageApprovalsPage),
    data: { 
      showHeader : true,
      title : {
        showTitle: true,
        label: 'Portal Settings'
      },
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'manageApprovals'
      },
      // secondaryMenu : {
      //   showMenu: true,
      //   highlightMenu: 'manageApprovals'
      // }
    }
  },
  {
    path: 'report-analytics',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-report-analytics/rs-report-analytics.page').then( m => m.RsReportAnalyticsPage),
    data: { 
      showHeader : true,
      title : {
        showTitle: true,
        label: 'Portal Settings'
      },
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'reportAnalytics'
      },
      // secondaryMenu : {
      //   showMenu: true,
      //   highlightMenu: 'reportAnalytics'
      // }
    }
  },
  {
    path: 'pick-list',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-pick-list/rs-pick-list.page').then( m => m.RsPickListPage),
    data: { 
      showHeader : true,
      title : {
        showTitle: true,
        label: 'Portal Settings'
      },
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'pickList'
      },
      // secondaryMenu : {
      //   showMenu: true,
      //   highlightMenu: 'pickList'
      // }
    }
   
  },
  {
    path: 'pick-list-detail',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-pick-list-detail/rs-pick-list-detail.page').then( m => m.RsPickListDetailPage),
       data: { 
      showHeader : true,
      title : {
        showTitle: true,
        label: 'Portal Settings'
      },
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'pickList'
      },
      // secondaryMenu : {
      //   showMenu: true,
      //   highlightMenu: 'pickList'
      // }
    }
  },

{
    path: 'grn',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-grn/rs-grn.page').then( m => m.RsGrnPage),
           data: { 
      showHeader : true,
     
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'GRN'
      }

    }
  },
 
  {
    path: 'grn-detail',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-grn/rs-grn-detail/rs-grn-detail.page').then( m => m.RsGrnDetailPage),
              data: { 
      showHeader : true,
     
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'GRN'
      }

    }
  },
  {
    path: 'token-attachment',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-token-attachment/rs-token-attachment.page').then( m => m.TokenAttachmentPage),
                  data: { 
      showHeader : true,
     
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'Token Attachment'
      }

    }
  },
  {
    path: 'token-attachment-create',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-token-attachment/rs-token-attachment-create/rs-token-attachment-create.page').then( m => m.TokenAttachmentCreatePage),
                     data: { 
      showHeader : true,
     
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'Token Attachment'
      }

    }
  },
  
  {
    path: 'vendor-dispatch-approval',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-vendor-dispatch-approval/rs-vendor-dispatch-approval.page').then( m => m.RsVendorDispatchApprovalPage),
    data: { 
      showHeader : true,
     
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'Vendor Dispatch Approval'
      }

    }
  },
  {
    path: 'vendor-dispatch-approval-detail',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-vendor-dispatch-approval/rs-vendor-dispatch-approval-detail/rs-vendor-dispatch-approval-detail.page').then( m => m.RsVendorDispatchApprovalDetailPage),
     data: { 
      showHeader : true,
     
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'Vendor Dispatch Approval'
      }

    }
  },
  {
    path: 'activation-request',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-activation-request/rs-activation-request.page').then( m => m.RsActivationRequestPage),
    data: { 
      showHeader : true,
     
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'Activation Request'
      }

    }
  },
  {
    path: 'activation-detail',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-activation-request/rs-activation-detail/rs-activation-detail.page').then( m => m.RsActivationDetailPage),
    data: { 
      showHeader : true,
     
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'Activation Request'
      }
    }
  },   

  {
    path: 'vendor-assignment',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-vendor-assignment/rs-vendor-assignment.page').then(m => m.RsVendorAssignmentPage),
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Vendor Assignment'
      },
      showSearch: true,

      menu: {
        showMenu: true,
        highlightMenu: 'vendorAssignment'
      }
    }
  },
  {
    path: 'finance',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-finance/rs-finance.page').then(m => m.RsFinancePage),
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Finance'
      },
      showSearch: true,

      menu: {
        showMenu: true,
        highlightMenu: 'finance'
      }
    }
  },
    {
      path: 'rs-vendor-assignment',
      canActivate: [authGuard],
      loadComponent: () => import('./features/rs-vendor-assignment/rs-vendor-assignment.page').then( m => m.RsVendorAssignmentPage)
    },
    {
    path: 'assignment-dispatch',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-assignment-dispatch/rs-assignment-dispatch.page').then(m => m.RsAssignmentDispatchPage),
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Assignment Dispatch'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'assignmentDispatch'
      }
    }
  },
  {
    path: 'rs-assignment-dispatch',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-assignment-dispatch/rs-assignment-dispatch.page').then( m => m.RsAssignmentDispatchPage)
  },
  {
    path: 'rs-finance',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-finance/rs-finance.page').then( m => m.RsFinancePage)
  },
 {
  path: 'issue-ticket',
  canActivate: [authGuard],
  loadComponent: () =>
    import('./features/rs-issue-tickets/rs-issue-tickets.page')
      .then(m => m.RsIssueTicketsPage),

  data: {
    showHeader: true,
    title: {
      showTitle: true,
      label: 'Issue Ticket'
    },
    showSearch: true,

    menu: {
      showMenu: true,
      highlightMenu: 'issueTicket'
    }
  }
},
  {
    path: 'token-attachment-bulk',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-token-attachment/rs-token-attachment-bulk/rs-token-attachment-bulk.page').then( m => m.TokenAttachmentBulkPage),
                      data: { 
      showHeader : true,
     
      showSearch : true,
      menu : {
        showMenu: true,
        highlightMenu: 'Token Attachment'
      }

    }
  },
 {
  path: 'portal-token-request',
  canActivate: [authGuard],
  loadComponent: () => import('./features/rs-portal-token-request/rs-portal-token-request.page').then(m => m.RsPortalTokenRequestPage),
  data: { 
    showHeader: true,
    title: {
      showTitle: true,
      label: 'Portal Token Request'
    },
    showSearch: true,
    menu: {
      showMenu: true,
      highlightMenu: 'profileSetting'
    },
    secondaryMenu: {
      showMenu: true,
      highlightMenu: 'portalTokenRequest'
    }
  }
},
  {
    path: 'promotions',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-promotion/rs-promotion.page').then( m => m.RsPromotionPage),
    data: { 
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Promotions'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'promotions'
      }
    }
  },
  {
    path: 'promotion-create',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-promotion-create/rs-promotion-create.page').then( m => m.RsPromotionCreatePage),
    canDeactivate: [unsavedChangesGuard],
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Promotions'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'promotions'
      }
    }
  },
  {
    path: 'promotion-details',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-promotion-details/rs-promotion-details.page').then( m => m.RsPromotionDetailsPage),
    data: { 
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Promotions'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'promotions'
      }
    }
  },
  {
    path: 'microsoft-callback',
    canActivate: [authGuard],
    loadComponent: () => import('./features/microsoft-callback/microsoft-callback.page').then( m => m.MicrosoftCallbackPage)
  },
  {
    path: 'product-catalog',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-product-catalog/rs-product-catalog.page').then(m => m.RsProductCatalogPage),
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Product Catalog'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'productCatalog'
      }
    }
  },
  {
    path: 'event',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-event/rs-event.page').then(m => m.RsEventPage),
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Event'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'event'
      }
    }
  },
  {
    path: 'stock',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-stock/rs-stock.page').then(m => m.RsStockPage),
    data: {
      showHeader: true,
      title: {
        showTitle: true,
        label: 'Stocks'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'stock'
      }
    }
  },
  
  {
  path: 'reports',
  canActivate: [authGuard],
  loadComponent: () => import('./features/reports/reports.page').then(m => m.ReportsPage),
  data: {
    showHeader: true,
    title: {
      showTitle: true,
      label: 'Reports'
    },
    showSearch: true,
    menu: {
      showMenu: true,
      highlightMenu: 'reports'
    }
  }
},
  
  {
  path: 'rs-token-search',
  canActivate: [authGuard],
  loadComponent: () => import('./features/rs-token-search/rs-token-search.page').then(m => m.RsTokenSearchPage),
  data: {
    showHeader: true,
    title: {
      showTitle: true,
      label: 'Token Search'
    },
    showSearch: true,
    menu: {
      showMenu: true,
      highlightMenu: 'tokenSearch'
    }
  }
},

  {
    path: 'update-password',
   // canActivate: [authGuard],
    loadComponent: () => import('./features/update-password/update-password.page').then( m => m.UpdatePasswordPage)
  },
  {
    path: 'system-notifications',
    canActivate: [authGuard],
    loadComponent: () => import('./features/rs-system-notifications/rs-system-notifications.page').then( m => m.RsSystemNotificationsPage),
    data: { 
      showHeader: true,
      title: {
        showTitle: true,
        label: 'System Notification'
      },
      showSearch: true,
      menu: {
        showMenu: true,
        highlightMenu: 'System Notification'
      }
    }
  },
 {
  path: 'rs-category',
  canActivate: [authGuard],
  loadComponent: () =>
    import('./features/rs-category/rs-category.page')
      .then(m => m.RsCategoryPage),
  data: {
    showHeader: true,
    title: {
      showTitle: true,
      label: 'Portal Settings'
    },
    showSearch: true,
    menu: {
      showMenu: true,
      highlightMenu: 'category'
    }
  }
},


];



  // {
  //   path: 'rs-reusable-upload-modal',
  //   loadComponent: () => import('./shared/components/rs-reusable-upload-modal/rs-reusable-upload-modal.page').then( m => m.RsReusableUploadModalPage)
  // }
  // {
  //   path: 'rs-reusable-modal',
  //   loadComponent: () => import('./shared/components/rs-reusable-modal/rs-reusable-modal.page').then( m => m.RsReusableModalPage)
  // },
  // {
  //   path: 'rs-headers',
  //   loadComponent: () => import('./shared/components/rs-headers/rs-headers.page').then( m => m.RsHeadersPage)
  // },
  // {
  //   path: 'rs-menu',
  //   loadComponent: () => import('./shared/components/rs-menu/rs-menu.page').then( m => m.RsMenuPage)
  // },
  // {
  //   path: 'rs-case-management',
  //   loadComponent: () => import('./features/rs-case-management/rs-case-management.page').then( m => m.RsCaseManagementPage)
  // },
  // {
  //   path: 'rs-data-table',
  //   loadComponent: () => import('./shared/components/rs-data-table/rs-data-table.page').then( m => m.RsDataTablePage)
  // }